
export default defineNuxtPlugin(() => {
  try {
    localStorage.removeItem('rootState_weatherData')
    localStorage.removeItem('rootState_weatherData_exp')
  } catch {
    //
  }
})
